document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.header');
	const hamburger = document.querySelector('.header .hamburger');
	const mobileNav = document.querySelector('.mobileNav');
	hamburger.addEventListener('click', () => {
		hamburger.classList.toggle('hamburger--opened');
		header.classList.toggle('header--open');
		hamburger.setAttribute(
			'aria-expanded',
			hamburger.classList.contains('hamburger--opened')
		);
		mobileNav.classList.toggle('open');
	});
	let vh = window.innerHeight * 0.01;

	if (document.querySelector('.mobileNav__list .menu-item-has-children')) {
		let subMenus = document.querySelectorAll(
			'.mobileNav__list .menu-item-has-children'
		);
		subMenus.forEach((subMenu) => {
			let link = subMenu.querySelector('a');
			let span = subMenu.querySelector('span');
			let ul = subMenu.querySelector('ul');
			link.addEventListener('click', (e) => {
				if (subMenu.querySelector('span')) {
					e.preventDefault();
					ul.classList.toggle('sub-menu--open');
					span.classList.toggle('open');
				}
			});
		});
	}

	document.documentElement.style.setProperty('--vh', `${vh}px`);

	// window.addEventListener('resize', () => {
	// 	vh = window.innerHeight * 0.01;
	// 	document.documentElement.style.setProperty('--vh', `${vh}px`);
	// });

	if (document.querySelector('.clients')) {
		var clientSwiper = new Swiper('.clients__slider .swiper', {
			slidesPerView: 2,
			spaceBetween: 30,
			autoplay: {
				delay: 2500,
			},
			loop: 1,
			breakpoints: {
				500: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 3,
				},
				1000: {
					slidesPerView: 4,
					spaceBetween: 50,
				},
				1280:{
					slidesPerView: 6
				}
			},
		});
	}
	if (document.querySelector('.sliderCards')) {
		var clientSwiper = new Swiper('.sliderCards .swiper', {
			slidesPerView: 1.5,
			spaceBetween: 20,
			// autoplay: {
			// 	delay: 2500,
			// },
			loop: 1,
			slidesPerView: 'auto',
		});
	}
	if (document.querySelector('.clientsSlider')) {
		var clientSliderSwiper = new Swiper('.clientsSlider .swiper', {
			spaceBetween: 20,
			centeredSlides: 1,
			loop: true,
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
			},
			slidesPerView: 'auto',
			speed: 4000,
			addSlidesBefore: 10,
			addSlidesAfter: 10,
			grabCursor: true,
			loopedSlides: 5,
			mousewheelControl: true,
			keyboardControl: true,
		});
	}
	if (document.querySelector('.jobOffers__row  .swiper')) {
		var jobOffersSlider = new Swiper('.jobOffers__row  .swiper', {
			spaceBetween: 20,
			slidesPerView: 1,
			loop: true,
			speed: 500,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			breakpoints: {
				400: {
					slidesPerView: 2,
				},
				1280:{
					slidesPerView: 3
				}
			},
		});
	}
});
